import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { environment } from 'environments/environment';

import { billPaymentTypes, config, paymentTypes } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';

import { HelperService, HTTPService, CalculationService, FormatService, DateService, DataService, SocketService } from 'app/services';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-supplier-bulk-payment',
  templateUrl: './supplier-bulk-payment.component.html',
  styleUrls: ['./supplier-bulk-payment.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupplierBulkPaymentComponent implements OnInit {
  @ViewChild('dt') table: Table;
  usd: string = currency.USD;
  cashPaymentMethods: any[] = [];
  cardPaymentMethods: any[] = [];
  otherPaymentMethods: any[] = [];
  paymentMethods: any[] = [];
  paymentTypes: any[] = paymentTypes;
  paymentMethodsActive = {
    cheque: true,
    cash: true,
    card: true,
  };
  selectedPaymentMethod: any = {};
  selectedPaymentType: any = {};

  paymentDate: any;
  createdAt: any;
  maxDateRange: any = new Date();
  activeColumn = '';
  filterQuery: any = <any>{
    page: 1,
    limit: 1000,
    sortField: 'code',
    sortOrder: -1,
    skip: 0,
    sort: 'order',
    order: 1,
  };

  filterOptions = {
    payableStatus: true,
  };

  customerId: string = '';
  companyId: string = '';
  isLoading: boolean = false;
  supplier: any = {};
  purchaseOrder: any = [];
  dupPurchaseOrder: any = [];
  totalRecords: any;
  loading: boolean = true;
  noRecFound: boolean = false;
  isItemLoading: boolean = false;
  isProcessing: boolean = false;
  preAppliedFilters: any = null;

  selectedItems: any = {};
  headerColumns = {
    code: true,
    payableStatus: false,
    dueDate: false,
    totalAmount: false,
    totalUnpaid: false,
    totalUnpaidPayment: false,
  };

  cols: any[] = [
    {
      field: 'checkbox',
      header: '',
      isShowSortIcon: false,
      className: 'statement-checkbox',
    },
    {
      field: 'code',
      header: 'code',
      isShowSortIcon: false,
      className: 'purchase-order',
    },
    {
      field: 'payableStatus',
      header: 'Payable status',
      isShowSortIcon: false,
      className: 'vehicle',
    },
    {
      field: 'dueDate',
      header: 'Due date',
      isShowSortIcon: false,
      className: 'invoice-date',
    },
    {
      field: 'totalAmount',
      header: 'Total order value',
      isShowSortIcon: false,
      className: 'payment-status',
    },
    {
      field: 'totalUnpaid',
      header: 'Balance due',
      isShowSortIcon: false,
      className: 'total-value',
    },
    {
      field: 'totalUnpaidPayment',
      header: 'Payment amount',
      isShowSortIcon: false,
      className: 'amount-remaning',
    },
  ];
  paymentTime: any = '';
  tableCheckState: number = 0;
  activePayment: any = this.paymentTypes[0];
  payment: any = {
    collectedAmount: null,
    createdAt: '',
    method: {
      methodId: '',
      qboId: '',
      name: '',
      type: '',
    },
    paymentType: this.activePayment.value,
    card4Digits: '',
    cardConfNo: '',
    cardType: '',
    checkNo: '',
    notes: '',
    paymentTime: this.dateService.getCurrentDateTimeTz(new Date().getTime()),
    paymentDate: this.dateService.getCurrentDateTimeTz(new Date().getTime()),
  };

  featureIsPayRixEnable: boolean;
  isPayrixConnected: Boolean;
  isPaymentOnline = false;
  afterPayrixPayment = false;
  afterSwipePayment: boolean;
  paymentId: any;
  isSwipeOnline: boolean = false;
  isMethodLoading: boolean = false;
  supplierTotal = {
    ordersCount: 0,
    totalBalanceDue: 0,
    totalPaymnetAmount: 0,
  };
  focus: any = { name: true };
  errors: any = {};
  isValid: boolean = true;
  isQboConnected: any = false;

  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    public calculationService: CalculationService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dialogService: DialogService,
    private formatService: FormatService,
    private dateService: DateService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private socketService: SocketService
  ) {
    this.featureIsPayRixEnable = this.dataService.isOnlinePaymentEnable;
    this.isPayrixConnected = this.dataService.isPayrixConnected;
  }

  ngOnInit() {
    const { supplier } = this.dynamicDialogConfig.data;
    this.isQboConnected = this.helperService.getCompany().qbo;

    this.supplier = supplier;
    this.fetchPaymentMethods();
    this.getAllOrderList();

    if (this.isQboConnected) {
      this.paymentTypes = billPaymentTypes;
      this.activePayment = this.paymentTypes[0];
    }
  }

  getAllOrderList() {
    this.filterQuery = {
      supplier: this.supplier._id,
      type: this.supplier?.type?.value,
      payableStatus: this.filterQuery.payableStatus,
      sortOrder: this.filterQuery.sortOrder,
      sortField: this.filterQuery.sortField,
      bulkPaymentList: true,
    };

    this.isItemLoading = true;
    this.httpService
      .getSupplierPurchaseOrders(this.filterQuery)
      .then(
        (purchaseOrder: any) => {
          if (purchaseOrder.records.length > 0) {
            this.purchaseOrder = purchaseOrder.records.map((record: any) => ({
              ...record,
              dateOrdered: record.dateOrdered ? this.dateService.getCurrentDateTimeTz(new Date(record.dateOrdered).getTime()) : '',
              accPayableTerm: record.accPayableTerm ? record.accPayableTerm.name : '',
              totalUnpaidPayment: record.totalUnpaid,
            }));
            this.dupPurchaseOrder = this.helperService.deepCopy(this.purchaseOrder);
            this.totalRecords = purchaseOrder.records.length;
            this.noRecFound = this.purchaseOrder.length === 0 ? true : false;
          } else {
            this.noRecFound = true;
            this.totalRecords = 0;
            this.purchaseOrder = [];
            this.supplierTotal = {
              ordersCount: 0,
              totalBalanceDue: 0,
              totalPaymnetAmount: 0,
            };
          }
        },
        (error) => {
          this.helperService.showToaster('error', error);
        }
      )
      .finally(() => {
        this.isItemLoading = false;
      });
  }

  handleOpenPO(poData) {
    if (poData.type == 'orderLevel') {
      this.helperService.openPageInNewExistingTab(`/estimate/${poData.roId}?tab=3`, poData._id);
    } else {
      this.helperService.openPageInNewExistingTab(`/purchase-order/${poData._id}`, poData._id);
    }
    // this.helperService.openPageInNewExistingTab(`/purchase-order/${poId}`, poId);
  }

  customSort({ sortField, sortOrder }) {
    if (sortField === 'checkbox') return;

    this.filterQuery.sortField = sortField;
    this.filterQuery.sortOrder = sortOrder;
    this.getAllOrderList();
  }

  /** Fetch payments and set the qboId for the non credit card payment */
  fetchPaymentMethods() {
    if (!environment.isMock) {
      this.isMethodLoading = true;
      this.httpService.getActivePaymentMethods(true).then(
        (paymentMethods: any[]) => {
          this.paymentMethods = paymentMethods.filter(({ integrationType }) => integrationType === 'accPayable');

          if (this.isQboConnected) {
            this.paymentMethods.forEach((method) => {
              if (method.type === 'creditCard') {
                this.cardPaymentMethods.push(method);
              } else if (method.type === 'bank') {
                this.cashPaymentMethods.push(method);
              } else if (method.type === 'otherCurrentAsset') {
                this.otherPaymentMethods.push(method);
              }
            });
          } else {
            this.paymentMethods.forEach((method) => {
              if (method.type === 'CREDIT_CARD') {
                this.cardPaymentMethods.push(method);
              } else if (method.type === 'CASH') {
                this.cashPaymentMethods.push(method);
              } else if (method.name.toLowerCase().includes('cash')) {
                this.cashPaymentMethods.push(method);
              } else {
                this.otherPaymentMethods.push(method);
              }
            });
          }

          this.paymentMethodsActive = {
            card: !!this.cardPaymentMethods.length,
            cash: !!this.cashPaymentMethods.length,
            cheque: !!this.otherPaymentMethods.length,
          };

          if (!this.paymentId && this.cashPaymentMethods.length) {
            this.selectedPaymentMethod = this.cashPaymentMethods[0];
            this.activateMethodCard(this.paymentTypes[0]);
            this.selectedPaymentType = this.paymentTypes[0];
          }

          if (!this.paymentId) {
            if (this.cashPaymentMethods.length) {
              this.selectedPaymentMethod = this.cashPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[0]);
            } else if (this.cardPaymentMethods.length) {
              this.selectedPaymentMethod = this.cardPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[1]);
            } else if (this.otherPaymentMethods.length) {
              this.selectedPaymentMethod = this.otherPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[2]);
            }
          }
          this.isMethodLoading = false;
          this.setPaymentMethod();
        },
        (err) => {
          this.isMethodLoading = false;
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  setPaymentMethod() {
    if (this.payment.paymentMethod && this.payment.paymentMethod.methodId && this.paymentMethods.length) {
      const [paymentMethod] = this.paymentMethods.filter(({ _id }) => _id === this.payment.paymentMethod.methodId);
      const [activePaymentType] = this.paymentTypes.filter(({ value }) => this.payment.paymentType === value);

      if (paymentMethod && activePaymentType) {
        this.selectedPaymentMethod = paymentMethod;
        this.activateMethodCard(activePaymentType);
      }
    }
  }

  onCardMethodSelect(card: any) {
    this.payment.cardType = card.name;
    this.selectedPaymentMethod = card;
  }

  activateMethodCard(method: any, changed = false) {
    if (this.isQboConnected) {
      if (method.value === 'creditCard') {
        this.paymentMethods = [...this.cardPaymentMethods];
      } else if (method.value === 'bank') {
        this.paymentMethods = [...this.cashPaymentMethods];
      } else {
        this.paymentMethods = [...this.otherPaymentMethods];
      }
    } else {
      if (method.value === 'card') {
        this.paymentMethods = [...this.cardPaymentMethods];
      } else if (method.value === 'cash' || method.value === 'bank') {
        this.paymentMethods = [...this.cashPaymentMethods];
      } else {
        this.paymentMethods = [...this.otherPaymentMethods];
      }
    }

    if (this.paymentMethods.length) {
      this.activePayment = method;
      if (changed) {
        this.selectedPaymentMethod = this.paymentMethods[0];
      }
    }
  }

  onDateTimeChange(date: any) {
    this.payment.paymentDate = date;
  }

  handleChangeNotes(value: any, field: string) {
    this.payment[field] = value;
  }

  handleAllListSelect(checkState: number) {
    this.supplierTotal.totalPaymnetAmount = 0;
    this.supplierTotal.ordersCount = 0;
    this.supplierTotal.totalBalanceDue = 0;
    this.purchaseOrder.forEach((data) => {
      if (checkState === 0 || checkState === 2) {
        this.selectedItems[data.sourceId] = data;
        this.supplierTotal.totalPaymnetAmount += data.totalUnpaidPayment;
        this.supplierTotal.ordersCount += 1;
        this.supplierTotal.totalBalanceDue += data.totalUnpaid;
      } else {
        delete this.selectedItems[data.sourceId];
        this.supplierTotal.totalPaymnetAmount = 0;
        this.supplierTotal.ordersCount = 0;
        this.supplierTotal.totalBalanceDue = 0;

        this.purchaseOrder.map((po, index) => {
          if (po._id === data._id) {
            po.totalUnpaidPayment = this.dupPurchaseOrder[index].totalUnpaidPayment;
          }
        });
      }
    });
    this.calculateItemTotal();
    this.isValidate();
  }

  handleItemSelect(data: any, isChecked: boolean) {
    if (isChecked) {
      this.selectedItems[data.sourceId] = data;
      this.supplierTotal.totalPaymnetAmount += data.totalUnpaidPayment;
      this.supplierTotal.ordersCount += 1;
      this.supplierTotal.totalBalanceDue += data.totalUnpaid;
    } else {
      this.supplierTotal.totalPaymnetAmount -= data.totalUnpaidPayment;
      this.supplierTotal.ordersCount -= 1;
      this.supplierTotal.totalBalanceDue -= data.totalUnpaid;

      delete this.selectedItems[data.sourceId];
      this.purchaseOrder.map((po, index) => {
        if (po._id === data._id) {
          po.totalUnpaidPayment = this.dupPurchaseOrder[index].totalUnpaidPayment;
        }
      });
    }
    this.calculateItemTotal();
    this.isValidate();
  }

  focusInput(type: string, _id) {
    if (_id) {
      this.focus[type] = true;
    }
  }

  handleBlur(type: string, _id) {
    if (_id) {
      this.focus[type] = false;
    }
  }

  handleTotalAmount(data: any = {}, value: any = 0) {
    if (value > data.totalUnpaid) {
      this.helperService.showToaster('error', 'Amount should be less than Balance due');
      return;
    }

    this.supplierTotal.totalPaymnetAmount -= data.totalUnpaidPayment;
    this.supplierTotal.totalPaymnetAmount += value === '' ? 0 : Number(value);

    this.selectedItems[data.sourceId] = data;

    // retaining new value to show in table
    this.purchaseOrder.map((po) => {
      if (po.sourceId === data.sourceId) {
        po.totalUnpaidPayment = value === '' ? 0 : Number(value);
      }
    });
  }

  calculateItemTotal() {
    // const sortedOrder: any = sortBy(Object.values(this.selectedItems), 'invoiceDate');

    // sortedOrder.forEach((order: any) => {
    //   this.supplierTotal.total += order.totalOrderAmount;
    //   this.supplierTotal.due += order.amountRemaning;
    //   this.supplierTotal.paid += order.paid;
    //   this.supplierTotal.count++;
    // });

    const selectedItemCount = Object.keys(this.selectedItems).length;

    if (selectedItemCount === 0) {
      this.tableCheckState = 0;
    } else if (selectedItemCount === this.purchaseOrder.length) {
      this.tableCheckState = 1;
    } else {
      this.tableCheckState = 0;
    }
  }

  filterChange(filter?: any, options: any = {}) {
    const { poStatus, supplier, payableStatus, paymentStatus } = filter;
    this.handleAllListSelect(1);
    this.tableCheckState = 0;
    this.filterQuery.payableStatus = payableStatus;
    this.getAllOrderList();
  }

  /* To conditionally display table sorting icon on column header*/
  showIcon(columnName: string) {
    Object.keys(this.headerColumns).forEach((col) => {
      if (columnName === col) {
        this.headerColumns[columnName] = true;
      } else {
        this.headerColumns[col] = false;
      }
    });

    this.cols.forEach((c, ci) => {
      this.cols[ci].isShowSortIcon = c.field === columnName;
    });
  }

  handleChange(value: any, field: string) {
    if (field === 'collectedAmount') {
      this.payment[field] = !isNaN(value.replace(',', '')) ? Number(value.replace(',', '')) : value;
      this.payment.estimate.unpaid = this.payment.estimate.total - this.payment.collectedAmmount;
    } else if (field !== 'card4Digits' && field !== 'cardConfNo' && field !== 'checkNo') {
      this.payment[field] = Number(value);
    } else {
      this.payment[field] = value;
    }
  }

  isValidate() {
    this.isValid = true;
    const selectedListItems = [];

    for (var key of Object.keys(this.selectedItems)) {
      selectedListItems.push(this.selectedItems[key]);
    }

    if (selectedListItems.length > 0) {
      // this.errors.billableHours = 'Please select atleat 1 order';
      this.isValid = false;
    } else {
      this.isValid = true;
    }
    return this.isValid;
  }

  handleSubmitPayment() {
    if (!this.isValidate()) {
      const selectedListItems = [];

      this.payment.paymentType = this.activePayment.value;
      this.payment.paymentMethod = {
        methodId: this.selectedPaymentMethod._id,
        qboId: this.selectedPaymentMethod.qboId,
        name: this.selectedPaymentMethod.name,
        type: this.activePayment.value,
      };
      const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
      const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
      const paymentDate = `${date} ${time}`;

      for (var key of Object.keys(this.selectedItems)) {
        selectedListItems.push(this.selectedItems[key]);
      }

      const finalPaymnetData = { ...this.payment, paymentDate };
      const body = {
        payload: finalPaymnetData,
        pos: selectedListItems,
        collectedAmount: this.supplierTotal.totalPaymnetAmount,
      };

      this.saveSupplierBulkPayment(body);
    }
  }

  saveSupplierBulkPayment(data) {
    this.isProcessing = true;
    this.httpService.createBulkPayablePayment(data).then(
      (res) => {
        this.helperService.showToaster('success', 'Bulk payment created');
        this.dataService.sendData(this.dataService.typeSupplierSideBar('supplier', this.supplier._id, this.supplier.supplierName, this.supplier));
        this.isProcessing = false;
        this.dynamicDialogRef.close();
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  closeDialog() {
    this.dynamicDialogRef.close();
  }
}
